export const Panel = ({ title, action, children, testid }) => (
  <section
    className="rounded-xl border border-cream/10 bg-[#10211A] p-5 sm:p-6"
    data-testid={testid}
  >
    {(title || action) && (
      <div className="mb-5 flex items-center justify-between gap-4">
        {title ? (
          <h2 className="font-mono text-[10px] uppercase tracking-[0.28em] text-gold/80">{title}</h2>
        ) : (
          <span />
        )}
        {action}
      </div>
    )}
    {children}
  </section>
);

export const Stat = ({ label, value, hint, testid }) => (
  <div className="rounded-xl border border-cream/10 bg-[#10211A] px-5 py-5" data-testid={testid}>
    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-cream/45">{label}</p>
    <p className="mt-3 font-serif text-3xl leading-none text-cream">{value}</p>
    {hint ? <p className="mt-2 text-xs text-cream/40">{hint}</p> : null}
  </div>
);

export const ScoreBar = ({ score }) => {
  const tone = score >= 80 ? "bg-gold" : score >= 60 ? "bg-sage" : "bg-cream/30";
  return (
    <div className="flex items-center gap-2">
      <div className="h-1 w-14 overflow-hidden rounded-full bg-cream/10">
        <div className={`h-full ${tone}`} style={{ width: `${score}%` }} />
      </div>
      <span className="font-mono text-xs text-cream/70">{score}</span>
    </div>
  );
};

export const Pill = ({ children, tone = "neutral" }) => {
  const tones = {
    neutral: "border-cream/15 text-cream/60",
    gold: "border-gold/40 text-gold",
    terra: "border-terra/40 text-terra",
    sage: "border-sage/40 text-sage",
  };
  return (
    <span className={`rounded-full border px-2.5 py-0.5 text-[11px] ${tones[tone]}`}>
      {children}
    </span>
  );
};

export const Field = ({ label, value, testid }) => (
  <div data-testid={testid}>
    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-cream/40">{label}</p>
    <p className="mt-1.5 text-sm text-cream/90">{value || "—"}</p>
  </div>
);

export const inputClass =
  "w-full rounded-lg border border-cream/15 bg-cream/5 px-3 py-2 text-sm text-cream outline-none transition-colors duration-200 placeholder:text-cream/25 focus:border-gold/60";

export const buttonClass =
  "inline-flex items-center justify-center gap-2 rounded-full bg-cream px-5 py-2.5 text-xs font-medium text-forest transition-all duration-300 hover:-translate-y-0.5 hover:bg-gold disabled:cursor-not-allowed disabled:opacity-60";
